import { useMemo } from "react";
import type { ImmutableObject } from "@/lib/immutable";
import { createStore, type Store, useStore } from "./store";

export class SessionLocalStorageModel {
	loggedIn: boolean = false;
	authToken: string = "";
	fullName: string = "";
	email: string = "";
}

const storefront_sessionstate_key = "storefront-sessionstate";
let initialState = new SessionLocalStorageModel();
const localstorageJson = window.localStorage.getItem(
	storefront_sessionstate_key,
);
if (localstorageJson) {
	try {
		initialState = JSON.parse(localstorageJson);
	} catch (ex) {
		console.error(ex);
	}
}
const sessionStateStore = createStore<SessionLocalStorageModel>(initialState);

export class SessionState {
	private sessionState: Store<SessionLocalStorageModel>;

	constructor(sessionState: Store<SessionLocalStorageModel>) {
		this.sessionState = sessionState;
	}

	get(): ImmutableObject<SessionLocalStorageModel> {
		return this.sessionState.getState();
	}

	reset() {
		this.sessionState.setState(new SessionLocalStorageModel());
		this.saveToLocalStorage();
	}

	private saveToLocalStorage() {
		const obj = this.sessionState.getState();
		let json = "";
		if (obj) {
			json = JSON.stringify(obj);
		}
		window.localStorage.setItem(storefront_sessionstate_key, json);
	}

	set(sessionState: SessionLocalStorageModel) {
		this.sessionState.setState(sessionState);
		this.saveToLocalStorage();
	}
}

export function useSessionState(): SessionState {
	useStore(sessionStateStore);
	return useMemo(() => new SessionState(sessionStateStore), []);
}
